const rendererCache = new WeakMap();

export default class RendererCacheManager {
  constructor(instance, row, column) {
    this.instance = instance;
    this.cacheKey = `${row}/${column}`;

    if (!rendererCache.has(instance)) {
      rendererCache.set(instance, {});
      instance.addHookOnce('afterDestroy', () => {
        rendererCache.delete(instance);
      });
    }
  }

  get cache() {
    return rendererCache.get(this.instance)[this.cacheKey];
  }

  setCache(cacheParams = {}) {
    const instanceCache = rendererCache.get(this.instance);
    instanceCache[this.cacheKey] = cacheParams;
    rendererCache.set(this.instance, instanceCache);

    return instanceCache[this.cacheKey];
  }
}
